import owd from 'owd/owd';
import 'lib/billboard';

export default class InjectCharts extends owd.Component {
	init() {
        this.tableBody = this.$element.find('table tbody');
        
        this.injectButton();
		this.bind();
	}
    
    injectButton() {
        this.tableBody.find('tr').each((i, row) => {
            row = $(row); 
            
            const firstColInRow = row.find('td').first();
            
            firstColInRow.html((i, oldHTML) => {
                return oldHTML = `<button class="button button--chart" aria-label="Pokaż wykres">
                                    <span class="button-chart"></span>
                                  </button>
                                  <span>${oldHTML}</span>`; 
            });
        });
    }
    
//    replace(regexp, str, replacement) {
//        if(regexp.test(str)) {
//            str = str.replace(regexp, replacement);
//        }
//        
//        return str
//    }
    
    parseNumber(value = 0) {
        if(/\,/g.test(value)) {
            value = value.replace(/\,/g, '.');
        } 
        
        if(/\%/g.test(value)) {
            value = value.replace(/\%/g, '');
        }
        
        if(/\s/g.test(value)) {
            value = value.replace(/\s+/g, '');
        }

        value = Number(value);

        return value;
    }

	bind() {
        this.on('click', '.button--chart', (e) => {
            const target = $(e.currentTarget);
            const chartModal = target.closest('.tabs').find('.tabs-chart');
            const row = target.closest('tr');
            const theadRows = target.closest('table').find('thead tr');
            
            const xLabels = [];
            const values = [];
            
            row.children().each((i, col) => {
                col = $(col);
                
                if(i !== 0 && i !== 1) {
                    values.push(col.text());
                }
            });
            
            theadRows.children().each((i, col) => {
                col = $(col);
                
                if(i !== 0 && i !== 1) {
                    xLabels.push(col.text());
                }
            });
            
            const x = ['x'].concat(xLabels);
            const dataValue = values.map((value) => {
                return this.parseNumber(value);
            });
            
            const dataName = row.find('td').first().text().trim();
            const unit = row.find('td').first().next().text().trim();
            
            const chart = bb.generate({
                bindto: '.tabs-chart-container',
                data: { 
                    //x: "x",
                    type: "bar",
                    columns: [
                        //x,
                        [dataName].concat(dataValue)
                    ],
                    color: (color, d) => {
                        return '#F2920A';
                    },
                },
                
                legend: {
                    //position: 'bottom'
                    //show: false,
                    contents: {
                        bindto: '.tabs-chart-legend',
                        
                        template: (title, color, data) => {
                            if(/\(((?:\\.|[0-9])*)\)/g.test(title)) {
                                const footnote = /\(((?:\\.|[0-9])*)\)/g.exec(title)[0];
                                title = title.replace(/\(((?:\\.|[0-9])*)\)/g, '');
                                title = `${title}<span style="display: inline-block; font-size: 10px; transform: translateY(-6px);">${footnote}</span>`
                            }
                            return `<li class="legend-item">
                                        <span class="legend-item-color" style="background-color: ${color};"></span>
                                        <span class="legend-item-label">${title}</span>
                                    </li>`;
                        }
                    }
                },
                
                axis: {
                    y: {
                        show: false,
                        /*tick: {
                            format: (x) => {
                                return parseInt(x, 10);
                            },
                            count: 3
                        }*/
                    },
                    x: {
                        tick: {
                            format: (x, y) => {
                                //console.log(/\((?:[\w])*\)/g.exec(xLabels[x]));
                                //const reg = /\([\w]*\)/g;
                                //console.log(reg.test(xLabels[x]), "1");
                                //console.log(/\([\w]*\)/g.exec(xLabels[x]), "2");
                                //if(reg.test(xLabels[x])) {
                                //    const footnote = /\([\w]*\)/g.exec(xLabels[x]);
                                //    console.log(footnote);
                                //    const label = xLabels[x].replace(reg, '');
                                //    return `${label} <tspan baseline-shift="super">${footnote}</tspan>`;
                                //}
                                
                                return xLabels[x];
                            }
                        }
                    }
                },
                
                tooltip: {
                    contents: (d, defaultTitleFormat, defaultValueFormat, color) => {
                        //const value = this.dom.$html.attr('lang') === 'pl-PL' ? d[0].value.toString().replace(/\./g, ',') : d[0].value; 
                        
                        let name = d[0].name;
                        let label = xLabels[d[0].x];
                        let value = values[d[0].x];
                        
                        if(/\(((?:\\.|[0-9])*)\)/g.test(label)) {
                            const footnote = /\(((?:\\.|[0-9])*)\)/g.exec(label)[0];
                            label = label.replace(/\(((?:\\.|[0-9])*)\)/g, '');
                            label = `${label}<span style="transform: translateY(-6px); font-size: 10px; display: inline-block;">${footnote}</tspan>`;
                        }
                        
                        
                        if(/\(((?:\\.|[0-9])*)\)/g.test(name)) {
                            const footnote = /\(((?:\\.|[0-9])*)\)/g.exec(name)[0];
                            name = name.replace(/\(((?:\\.|[0-9])*)\)/g, '');
                            name = `${name}<span style="display: inline-block; font-size: 10px; transform: translateY(-6px);">${footnote}</span>`
                        }
                        
                        if(/\%/g.test(value)) {
                            value = value.replace(/\%/g, '');
                            
                            if($('.header').data('lang') !== 'pl' && /\,/g.test(value)) {
                                value = value.replace(/\,/g, '.');
                            }
                        }
                        
                        return `<div>
                                    <span>${name}</span>
                                    <span>${label}</span>
                                    <span>${value} ${unit}</span>
                                </div>`;
                    }
                },
                
                transition: {
                    duration: 500
                }
            });
            
            chart.categories(xLabels);
            
            //window.chartTest = chart;
            chartModal.addClass('is-visible');
        });
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('inject-charts', {
	component: InjectCharts
});
